import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {useHead} from "@vueuse/head";


export default /*#__PURE__*/_defineComponent({
  __name: 'MetaDefault',
  props: {
  title: { type: String, default: '' }
},
  setup(__props) {

const props = __props

useHead({
  title: `${props.title} | Штрафы`,
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span"))
}
}

})